module.exports = __webpack_public_path__ + "img/etc.8abed757.svg";